import React, { FC } from "react";
import { useIntl } from "react-intl";

import AvailabilityCalendarTimeSlots from "../../Unknown/AvailabilityCalendarTimeSlots";
import Alert from "../../Unknown/Alert";
import Box from "../../Unknown/Box";
import CircularProgress from "../../Unknown/CircularProgress";
import { useAppointmentBookingContext } from "../AppointmentBookingContext";
import { useAuthContext } from "../../Auth/AuthContextProvider";

const messages = {
  statCustomerInfo: {
    id: "AppointmentTimeSlotsSelecting.statCustomerInfo",
    defaultMessage: "Showing only dates and times with STAT availability",
  },
  statStaffInfo: {
    id: "AppointmentTimeSlotsSelecting.statStaffInfo",
    defaultMessage:
      "Showing all dates and times, regardless of STAT availability",
  },
};

const AppointmentTimeSlotsSelecting: FC = () => {
  const { formatMessage } = useIntl();

  const {
    selectedDate,
    selectedTimeSlot,
    onTimeSlotChange,
    selectedCenter,
    availableTimeSlots,
    isSubmitLoading,
    isStatAddOnSelected,
  } = useAppointmentBookingContext();

  const { isCenterUser } = useAuthContext();

  const { data, status } = availableTimeSlots;

  if (!selectedCenter || !selectedDate || status === "error") {
    return null;
  }

  if (status !== "success") {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
        mt={10}
      >
        <CircularProgress />
      </Box>
    );
  }

  const selectedDayDate = selectedDate.getDate();

  const availableCalendarTimeSlots =
    data.currentMonthTimeSlots[selectedDayDate]?.available || [];

  return (
    <>
      {isStatAddOnSelected && !isCenterUser && (
        <Box mb={2}>
          <Alert severity="info">
            {formatMessage(messages.statCustomerInfo)}
          </Alert>
        </Box>
      )}
      {isStatAddOnSelected && isCenterUser && (
        <Box mb={2}>
          <Alert severity="warning">
            {formatMessage(messages.statStaffInfo)}
          </Alert>
        </Box>
      )}
      <AvailabilityCalendarTimeSlots
        availableTimeSlots={availableCalendarTimeSlots}
        selectedTimeSlot={selectedTimeSlot}
        onTimeSlotChange={onTimeSlotChange}
        isDisabled={isSubmitLoading}
      />
    </>
  );
};

export default AppointmentTimeSlotsSelecting;
